import { AsyncAction, CommanderThunkAction } from '@mews-commander/types';
import { lt, showErrorAlert, showSuccessAlert } from '@mews/framework';
import { createFetchAction } from '@mews-commander/utils';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import { updateCreditLimits, addCreditLimits } from '@mews-commander/legacy-entities/src/actions/creditLimits';
import { CreditLimitFormValues } from './components/CreditLimitForm';
import { getCreditLimit } from './selectors';
import { CREDIT_LIMIT_CHANGED } from './actionTypes';

export const addOrUpdateCreditLimit =
    (
        { value, currencyCode }: CreditLimitFormValues,
        accountId: string
    ): CommanderThunkAction<AsyncAction, void | Promise<unknown>> =>
    async (dispatch, getState, { container }) => {
        const current = getCreditLimit(getState(), { accountId });
        const { parseCurrencyValue } = container().appLocalizationComponent;

        if (!current) {
            if (!value) {
                showErrorAlert({
                    description: lt('CreditLimitCannotBeEmptyErrorMessage'),
                });
                return;
            }
            const enterpriseId = getCurrentEnterpriseId();
            const creditLimits = [
                {
                    enterpriseId,
                    accountId,
                    amount: {
                        currencyCode,
                        value: parseCurrencyValue(value),
                    },
                },
            ];
            // @ts-expect-error $TSFixMeError: Type '{ enterpriseId: string; accountId: string; amount: { currencyCode: string | null; value: any; }; }[]' is not assig...
            const promise = (dispatch(addCreditLimits({ creditLimits })) as $TSFixMe).then(() =>
                showSuccessAlert({
                    description: lt('SaveSuccessMessage'),
                })
            );
            return dispatch(createFetchAction(CREDIT_LIMIT_CHANGED, promise));
        }

        const newValue = value ? { currencyCode, value: parseCurrencyValue(value) } : null;

        const creditLimits = [
            {
                id: current.id,
                amount: {
                    value: newValue,
                },
            },
        ];
        // @ts-expect-error $TSFixMeError: Type '{ id: string; amount: { value: { currencyCode: string | null; value: any; } | null; }; }[]' is not assignable to t...
        const promise = (dispatch(updateCreditLimits({ creditLimits })) as $TSFixMe).then(() =>
            showSuccessAlert({
                description: lt('SaveSuccessMessage'),
            })
        );
        return dispatch(createFetchAction(CREDIT_LIMIT_CHANGED, promise));
    };
